var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 186,
    viewBox: "0 0 299 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.925 -7.6787L461 165.51L163.078 369.724L0.00251979 196.535L297.925 -7.6787Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.925 7.67872L483 180.867L185.078 385.081L22.0025 211.892L319.925 7.67872Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.925 23.0361L503 196.225L205.078 400.438L42.0025 227.25L339.925 23.0361Z",
    fill: "white",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCard);
export default __webpack_public_path__ + "static/media/bg_card.472e6a6d74efae58dd1d87c3395e1ee2.svg";
export { ForwardRef as ReactComponent };